var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-slide-group',{staticClass:"carousel--wrapper project--slick",attrs:{"cycle":"","interval":"5000"}},_vm._l((_vm.contents),function(content,index){return _c('v-slide-item',{key:index,staticClass:"carousel--slide"},[_c('card-unit-type',{attrs:{"unitType":content,"allowMultiImage":false}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }